// extracted by mini-css-extract-plugin
export default {"functionalItemWrapper":"styles_functionalItemWrapper__t8mzm","imageWrapper":"styles_imageWrapper__HUQ8n","textWrapper":"styles_textWrapper__jyw2v"};